import SuperRepository from '../superRepository';

export default new class UserPerformanceRepository extends SuperRepository {
  baseUri () {
    return 'portal/user_performance';
  }
  exportReport = (uuid, data, params) => this.httpClient().postFile(this.baseUri() + `/${uuid}/export`, data, params);
  exportListReport = (data, params) => this.httpClient().post(this.baseUri() + `/export`, data, params);
  bulkUpdate = ({edit, ...filters}) => this.httpClient().post(this.baseUri() + `/bulk_edit?edit=${edit}`, filters);
  sendToLeader = (uuid) => this.httpClient().post(this.baseUri() + `/${uuid}/send_to_leader`);
  sendToAdminCnBFromUser = (uuid) => this.httpClient().post(this.baseUri() + `/${uuid}/approve_by_user`);
  sendToReproveByLeader = (uuid) => this.httpClient().post(this.baseUri() + `/${uuid}/send_to_reprove_by_leader`);
  cancelByLeader = (uuid, params) => this.httpClient().post(this.baseUri() + `/${uuid}/cancel_by_leader`, params);
  sendToAdminCnB = (uuid) => this.httpClient().post(this.baseUri() + `/${uuid}/approve_by_leader`);
  approveByAdminCnB = (uuid) => this.httpClient().post(this.baseUri() + `/${uuid}/approve_by_administrator_cb`);
  cancelByAdminCnB = (uuid, params) => this.httpClient().post(this.baseUri() + `/${uuid}/cancel_by_administrator_cb`, params);
}
